import DateTimePicker from "./vue/dateTimePicker/DateTimePicker";

// defining this here so the DatePicker import gets used
customElements.define("sky-datetimepicker", DateTimePicker);

export function closeModal(element: JQuery<HTMLElement>)
{
    const control = element.closest("sky-datetimepicker");
    if (control.length > 0 && (control[0] as any).closeModal)
    {
        (control[0] as any).closeModal()
    }
}